module.exports = __webpack_public_path__ + "static/media/about doctor.f4e714fa.png";